export enum TextFormats {
  bold = 'bold',
  italic = 'italic',
  underline = 'underline'
}

export const menuFontWeightConfiguration = [{
  value: TextFormats.bold,
  matIcon: 'format_bold',
  label: 'se-ui-text-editor_cmd_bold_tooltip'
}];

export const menuFontStyleConfiguration = [{
  value: TextFormats.italic,
  matIcon: 'format_italic',
  label: 'se-ui-text-editor_cmd_italic_tooltip'
}];

export const menuTextDecorationConfiguration = [{
  value: TextFormats.underline,
  matIcon: 'format_underline',
  label: 'se-ui-text-editor_cmd_underline_tooltip'
}];
